import { render, staticRenderFns } from "./MeEditorVote.vue?vue&type=template&id=0c5888bc&scoped=true"
import script from "./MeEditorVote.vue?vue&type=script&lang=js"
export * from "./MeEditorVote.vue?vue&type=script&lang=js"
import style0 from "./MeEditorVote.vue?vue&type=style&index=0&id=0c5888bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5888bc",
  null
  
)

export default component.exports